module.exports = __webpack_public_path__ + "CriticalBaths.jpg?9f47b36a8df0a4f4015e806a65a6ace6";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CriticalBaths.jpg
// module id = 457
// module chunks = 0